export const GET_DASHBOARD_CARD_INFO = "GET_DASHBOARD_CARD_INFO"
export const GET_DASHBOARD_CARD_INFO_SUCCESS = "GET_DASHBOARD_CARD_INFO_SUCCESS"
export const SEND_FEEDBACK = "SEND_FEEDBACK"
export const GET_WECREST_INFO = "GET_WECREST_INFO"
export const GET_WECREST_INFO_SUCCESS = "GET_WECREST_INFO_SUCCESS"
export const SET_DASHBOARD_CARD_LOADING = "SET_DASHBOARD_CARD_LOADING"